module.exports = "/images/arrow.svg?81b3aebc7915065961330d570a07b4b7";